export const ONE_MO_FILE_IN_BYTE = 1000000;